module.exports = __webpack_public_path__ + "img/imgrolebtn.b09d853e.png";